<template><section><h2>雷达图点样式</h2>
<block-demo tip="point" source="const data = [
  { label: &#39;sprite&#39;, category: &#39;类别一&#39;, value: 39 },
  { label: &#39;path&#39;, category: &#39;类别一&#39;, value: 72 },
  { label: &#39;ellipse&#39;, category: &#39;类别一&#39;, value: 40 },
  { label: &#39;rect&#39;, category: &#39;类别一&#39;, value: 46 },
  { label: &#39;triangle&#39;, category: &#39;类别一&#39;, value: 20 },
  { label: &#39;parallel&#39;, category: &#39;类别一&#39;, value: 52 },
  { label: &#39;regular&#39;, category: &#39;类别一&#39;, value: 62 },
  { label: &#39;star&#39;, category: &#39;类别一&#39;, value: 45 }
]

const { Chart, Radar, Tooltip, Legend } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})
chart.source(data, {
  row: &#39;category&#39;,
  value: &#39;value&#39;,
  text: &#39;label&#39;
})

const radar = new Radar()
const pointObj = {
  sprite: {
    pointType: &#39;sprite&#39;,
    size:[17,26],
    anchor: [0.5, 0.5],
    texture: &#39;https://p5.ssl.qhimg.com/t01a2bd87890397464a.png&#39;
  },
  path: {
    pointType: &#39;path&#39;,
    d:
      &#39;M480,437l-29-26.4c-103-93.4-171-155-171-230.6c0-61.6,48.4-110,110-110c34.8,0,68.2,16.2,90,41.8C501.8,86.2,535.2,70,570,70c61.6,0,110,48.4,110,110c0,75.6-68,137.2-171,230.8L480,437z&#39;,
    normalize: true,
    fillColor: &#39;#f37&#39;,
    lineWidth: 20,
    scale: 0.05
  },
  ellipse: {
    normalize: true,
    radiusX: 15,
    radiusY: 10,
    fillColor: &#39;green&#39;,
    pointType: &#39;ellipse&#39;
  },
  rect: {
    normalize: true,
    pointType: &#39;rect&#39;,
    size: [15, 15],
    fillColor: &#39;red&#39;
  },
  triangle: {
    normalize: true,
    pointType: &#39;triangle&#39;,
    sides: [15, 15],
    angle: 60,
    fillColor: &#39;#7cc&#39;
  },
  parallel: {
    normalize: true,
    pointType: &#39;parallel&#39;,
    sides: [10, 10],
    angle: 60,
    rotate: 60,
    fillColor: &#39;#c7c&#39;
  },
  regular: {
    normalize: true,
    pointType: &#39;regular&#39;,
    edges: 7,
    radius: 10,
    fillColor: &#39;blue&#39;
  },
  star: {
    normalize: true,
    pointType: &#39;star&#39;,
    angles: 5,
    innerRadius: 5,
    outerRadius: 10,
    fillColor: &#39;red&#39;
  }
}

radar.style(&#39;point&#39;, (d, data, i) =&gt; {
  return pointObj[data.label]
})
.style(&#39;section&#39;, (d) =&gt; ({ opacity: 0.3 }))

const legend = new Legend({ align: [&#39;center&#39;, &#39;bottom&#39;] })
chart.append([radar, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'sprite'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'类别一'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">39</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'path'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'类别一'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">72</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'ellipse'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'类别一'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">40</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'rect'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'类别一'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">46</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'triangle'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'类别一'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">20</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'parallel'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'类别一'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">52</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'regular'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'类别一'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">62</span> },
  { <span class="hljs-attr">label</span>: <span class="hljs-string">'star'</span>, <span class="hljs-attr">category</span>: <span class="hljs-string">'类别一'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">45</span> }
]

<span class="hljs-keyword">const</span> { Chart, Radar, Tooltip, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'category'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'label'</span>
})

<span class="hljs-keyword">const</span> radar = <span class="hljs-keyword">new</span> Radar()
<span class="hljs-keyword">const</span> pointObj = {
  <span class="hljs-attr">sprite</span>: {
    <span class="hljs-attr">pointType</span>: <span class="hljs-string">'sprite'</span>,
    <span class="hljs-attr">size</span>:[<span class="hljs-number">17</span>,<span class="hljs-number">26</span>],
    <span class="hljs-attr">anchor</span>: [<span class="hljs-number">0.5</span>, <span class="hljs-number">0.5</span>],
    <span class="hljs-attr">texture</span>: <span class="hljs-string">'https://p5.ssl.qhimg.com/t01a2bd87890397464a.png'</span>
  },
  <span class="hljs-attr">path</span>: {
    <span class="hljs-attr">pointType</span>: <span class="hljs-string">'path'</span>,
    <span class="hljs-attr">d</span>:
      <span class="hljs-string">'M480,437l-29-26.4c-103-93.4-171-155-171-230.6c0-61.6,48.4-110,110-110c34.8,0,68.2,16.2,90,41.8C501.8,86.2,535.2,70,570,70c61.6,0,110,48.4,110,110c0,75.6-68,137.2-171,230.8L480,437z'</span>,
    <span class="hljs-attr">normalize</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'#f37'</span>,
    <span class="hljs-attr">lineWidth</span>: <span class="hljs-number">20</span>,
    <span class="hljs-attr">scale</span>: <span class="hljs-number">0.05</span>
  },
  <span class="hljs-attr">ellipse</span>: {
    <span class="hljs-attr">normalize</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">radiusX</span>: <span class="hljs-number">15</span>,
    <span class="hljs-attr">radiusY</span>: <span class="hljs-number">10</span>,
    <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'green'</span>,
    <span class="hljs-attr">pointType</span>: <span class="hljs-string">'ellipse'</span>
  },
  <span class="hljs-attr">rect</span>: {
    <span class="hljs-attr">normalize</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">pointType</span>: <span class="hljs-string">'rect'</span>,
    <span class="hljs-attr">size</span>: [<span class="hljs-number">15</span>, <span class="hljs-number">15</span>],
    <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'red'</span>
  },
  <span class="hljs-attr">triangle</span>: {
    <span class="hljs-attr">normalize</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">pointType</span>: <span class="hljs-string">'triangle'</span>,
    <span class="hljs-attr">sides</span>: [<span class="hljs-number">15</span>, <span class="hljs-number">15</span>],
    <span class="hljs-attr">angle</span>: <span class="hljs-number">60</span>,
    <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'#7cc'</span>
  },
  <span class="hljs-attr">parallel</span>: {
    <span class="hljs-attr">normalize</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">pointType</span>: <span class="hljs-string">'parallel'</span>,
    <span class="hljs-attr">sides</span>: [<span class="hljs-number">10</span>, <span class="hljs-number">10</span>],
    <span class="hljs-attr">angle</span>: <span class="hljs-number">60</span>,
    <span class="hljs-attr">rotate</span>: <span class="hljs-number">60</span>,
    <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'#c7c'</span>
  },
  <span class="hljs-attr">regular</span>: {
    <span class="hljs-attr">normalize</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">pointType</span>: <span class="hljs-string">'regular'</span>,
    <span class="hljs-attr">edges</span>: <span class="hljs-number">7</span>,
    <span class="hljs-attr">radius</span>: <span class="hljs-number">10</span>,
    <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'blue'</span>
  },
  <span class="hljs-attr">star</span>: {
    <span class="hljs-attr">normalize</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">pointType</span>: <span class="hljs-string">'star'</span>,
    <span class="hljs-attr">angles</span>: <span class="hljs-number">5</span>,
    <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">5</span>,
    <span class="hljs-attr">outerRadius</span>: <span class="hljs-number">10</span>,
    <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'red'</span>
  }
}

radar.style(<span class="hljs-string">'point'</span>, (d, data, i) =&gt; {
  <span class="hljs-keyword">return</span> pointObj[data.label]
})
.style(<span class="hljs-string">'section'</span>, (d) =&gt; ({ <span class="hljs-attr">opacity</span>: <span class="hljs-number">0.3</span> }))

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">align</span>: [<span class="hljs-string">'center'</span>, <span class="hljs-string">'bottom'</span>] })
chart.append([radar, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>